var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { NgModule, Injector, APP_BOOTSTRAP_LISTENER } from '@angular/core';
import { Actions } from './actions';
import { EffectsSubscription, effects } from './effects-subscription';
import { runAfterBootstrapEffects, afterBootstrapEffects } from './bootstrap-listener';
var EffectsModule = (function () {
    function EffectsModule(effectsSubscription) {
        this.effectsSubscription = effectsSubscription;
    }
    EffectsModule_1 = EffectsModule;
    EffectsModule.run = function (type) {
        return {
            ngModule: EffectsModule_1,
            providers: [
                EffectsSubscription,
                type,
                { provide: effects, useExisting: type, multi: true }
            ]
        };
    };
    EffectsModule.runAfterBootstrap = function (type) {
        return {
            ngModule: EffectsModule_1,
            providers: [
                type,
                { provide: afterBootstrapEffects, useExisting: type, multi: true }
            ]
        };
    };
    EffectsModule = EffectsModule_1 = __decorate([
        NgModule({
            providers: [
                Actions,
                EffectsSubscription,
                {
                    provide: APP_BOOTSTRAP_LISTENER,
                    multi: true,
                    deps: [Injector, EffectsSubscription],
                    useFactory: runAfterBootstrapEffects
                }
            ]
        }),
        __metadata("design:paramtypes", [EffectsSubscription])
    ], EffectsModule);
    return EffectsModule;
    var EffectsModule_1;
}());
export { EffectsModule };
//# sourceMappingURL=effects.module.js.map


//////////////////
// WEBPACK FOOTER
// /home/runner/work/slipresistant/slipresistant/client/~/@ngrx/effects/src/effects.module.js
// module id = Wgxb
// module chunks = 3